import * as types from './mutation-types.js'

export const loadRestaurants = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/restaurants').then((response) => {
            commit(types.ADD_RESTAURANTS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadRestaurant = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`show/${id}/restaurant`).then((response) => {
            commit(types.LOAD_RESTAURANT, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storeRestaurant = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/store/restaurant', data).then((response) => {
            commit(types.ADD_RESTAURANT, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const getTeamsRestaurant = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/get/teams/restaurant').then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const getUserRestaurantPermissions = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/get/user/${id}/permissions/restaurant`).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}


export const updateRestaurant = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/${data.restaurant_id}/restaurant`, data).then((response) => {
            commit(types.LOAD_RESTAURANT, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const downloadRoomFileTemplate = ({ commit, dispatch, state }) => {

    return new Promise((resolve, reject) => {
        window.axios.get(`add/rooms/restaurant/template`).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storeMealInRestaurantWithCategories = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`restaurant/${data.restaurant_id}/meals/categories`, data).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storeMealInRestaurant = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`restaurant/${data.restaurant_id}/meals`, data).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const getRestaurantMeals = ({ commit, dispatch, state }, restaurant_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`restaurant/${restaurant_id}/meals`).then((response) => {
            commit(types.RESTAURANT_MEALS, {
                data: response.data.mealSaleElementCollection,
                restaurant_id
            })
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const deleteMealInRestaurant = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`restaurant/${data.restaurant_id}/meals`, {params: data}).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storeRoomsWithFile = ({ commit, dispatch, state }, data) => {
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('_method', 'POST');
    return new Promise((resolve, reject) => {
        window.axios.post(`restaurant/${data.restaurant_id}/import/rooms`, formData, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            console.log(response)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}


